<div data-test-automation="tenure-parent-lots">
  @for (lot of tenure.lots; track trackByIndex(lotIndex); let lotIndex = $index) {
    <div
      class="row"
      data-test-automation="tenure-parent-lot">
      <!-- Common property lot -->
      @if (showNonLotCommonProperty) {
        <div
          [ngClass]="{'col-xs-4': showNonLotCommonProperty}"
          data-test-automation="tenure-parent-lot-non-lot-common-property-options">
          <label class="control-label">{{getFormerTenureUIConfigLookup().commonPropertyLabel}}</label>
          @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
            <div
              class="input-group"
              >
              @for (option of nonLotCommonPropertyValues; track trackByIndex(optionIndex, option); let optionIndex = $index) {
                <label
                  class="nlr-radio"
                  title="{{option.toolTip}}"
                  >
                  <input
                    type="radio"
                    [name]="name+'nonLotCommonProperty_'+lotIndex+'_'+optionIndex"
                    [id]="name+'nonLotCommonProperty_'+lotIndex+'_'+optionIndex"
                    [value]="option.value"
                    [(ngModel)]="lot.nonLotCommonProperty"
                    [ngClass]="{'disabled': disabled || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                    required
                    data-test-automation="tenure-parent-lot-non-lot-common-property-option-{{option.value}}" />
                  <span>{{option.displayValue}}</span>
                </label>
              }
            </div>
          }
        </div>
      }
      @if (!lot.nonLotCommonProperty) {
        <div
          [ngClass]="{'col-xs-6': tenureNewLotsLandAttrs, 'col-xs-8': showNonLotCommonProperty, 'col-xs-12': !tenureNewLotsLandAttrs}">
          <label class="control-label required-input">{{getFormerTenureUIConfigLookup().parentTenureLotNumberDetailLabel}}</label>
          @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
            <div>
              <div
                class="input-group"
                [ngClass]="{'has-error': (parentLotIdentifierText | formFieldHasError)||parentLotIdentifierText.errors?.['nlrPattern']}">
                <span class="input-group-addon">
                  <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                  type="text"
                  [name]="name+'parentLotIdentifier_'+lotIndex"
                  class="form-control"
                  [id]="name+'parentLotIdentifier_'+lotIndex"
                  #parentLotIdentifierText="ngModel"
                  placeholder="Enter lot #"
                  [(ngModel)]="lot.parentLotIdentifier"
                  [nlrPattern]="lotPattern"
                  required
                  [disabled]="!!tenure.nonLotCommonProperty|| disabled || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)" />
                <span class="input-group-addon">
                  <i
                    class="nlrp-icon nlrp-icon-add"
                    [ngClass]="{'disabled': disabled || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                    (click)="!disabled && addLot(lotIndex)"
                  title="Add lot"></i>
                </span>
                <span class="input-group-addon">
                  <i
                    class="nlrp-icon nlrp-icon-remove"
                    [ngClass]="{'disabled': disabled || (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | disabledByPermissions)}"
                    (click)="!disabled && removeLot(lotIndex)"
                  title="Remove lot"></i>
                </span>
              </div>
              @if (parentLotIdentifierText.errors?.['nlrPattern']) {
                <div
                  class="help-block">
                  <span>Error!</span>
                  <span>Invalid</span>
                </div>
              }
            </div>
          }
          @if (lotVerifyError(lotIndex)) {
            <div
              class="help-block">
              <span>Error!</span>
              <span>{{lotVerifyError(lotIndex)}}</span>
            </div>
          }
          @if (!lotVerified(lotIndex)&& (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions)) {
            <div>
              <input
                type="checkbox"
                [name]="name+'parentLotVerified'+lotIndex"
                [id]="name+'parentLotVerified'+lotIndex"
                class="hidden"
                [(ngModel)]="lot.verified"
                [required]="true" />
            </div>
          }
          <span class="verify-status">
            @if (lotVerified(lotIndex)) {
              <i
              class="nlrp-icon nlrp-icon-verified-passed active"></i>
            }
            @if (lotVerifyError(lotIndex)) {
              <i
              class="nlrp-icon nlrp-icon-error error"></i>
            }
          </span>
        </div>
      }
      @if (lot.nonLotCommonProperty) {
        <div
          [ngClass]="{'col-xs-8': showNonLotCommonProperty}">
          <label class="control-label">{{getFormerTenureUIConfigLookup().parentTenureLotNumberDetailLabel}}</label>
          <div
            class="input-group"
            [ngClass]="{'has-error': nonLotCommonProperty.invalid && (nonLotCommonProperty.dirty || submitted)}">
            <input
              type="text"
              [name]="name+'nonLotCommonProperty'+lotIndex"
              [id]="name+'nonLotCommonProperty'+lotIndex"
              #nonLotCommonProperty="ngModel"
              class="form-control"
              [disabled]="!!lot.nonLotCommonProperty"
              [value]="nonLotCommonPropertyIdentifier"
              [ngModel]="nonLotCommonPropertyIdentifier"
              data-test-automation="tenure-parent-lot-non-lot-common-property-identifier" />
            <span class="input-group-addon">
              <i
                class="nlrp-icon nlrp-icon-add"
                [ngClass]="{'disabled': disabled}"
                (click)="!disabled && addLot(lotIndex)"
                title="Add lot"
              data-test-automation="tenure-parent-lot-add-lot"></i>
            </span>
            <span class="input-group-addon">
              <i
                class="nlrp-icon nlrp-icon-remove"
                (click)="!disabled && removeLot(lotIndex)"
                title="Remove lot"
              data-test-automation="tenure-parent-lot-remove-lot"></i>
            </span>
          </div>
          @if (duplicateNonLotCommonProperty(lotIndex)) {
            <div
              class="help-block"
              >
              <span>Error!</span>
              <span>Same plan cannot have more than one common property lot !!!.</span>
            </div>
          }
          @if (nonLotCommonPropertyVerifyError(lotIndex)) {
            <div
              class="help-block">
              <span>Error!</span>
              <span>{{nonLotCommonPropertyVerifyError(lotIndex)}}</span>
            </div>
          }
          @if (['EDIT_INFORMATION', 'VIEW_INFORMATION'] | hasPermissions) {
            <div>
              @if (!nonLotCommonPropertyVerified(lotIndex)) {
                <input
                  type="checkbox"
                  [name]="'nonLotCommonPropertyVerified'+name+lotIndex"
                  class="hidden"
                  [(ngModel)]="lot.verified"
                  [required]="true" />
              }
              <span class="verify-status">
                @if (nonLotCommonPropertyVerified(lotIndex)) {
                  <i
                  class="nlrp-icon nlrp-icon-verified-passed active"></i>
                }
                @if (nonLotCommonPropertyVerifyError(lotIndex)) {
                  <i
                  class="nlrp-icon nlrp-icon-error error"></i>
                }
              </span>
            </div>
          }
        </div>
      }
      @if (tenureNewLotsLandAttrs) {
        <div
          class="col-xs-6">
          <nlr-tenure-new-lot-detail
            [name]="name + lotIndex"
            [newLotDetails]="lot.newLotDetails">
          </nlr-tenure-new-lot-detail>
        </div>
      }
    </div>
  }
</div>
